import { EventEmitter } from 'expo-modules-core';

const emitter = new EventEmitter({} as any);

export default {
  set: (key: string, value: string) => console.log('todo'),
  get: (key: string) => console.log('todo'),
};
